/* global app */
/* global event */
/* global user, groups, gui, location, $ */
app.controller('topNavCtrl', ['$rootScope', '$scope', '$http', '$compile', 'NetworkService', 'AtlasDialog', 'AtlasNotification', '$timeout', function($rootScope, $scope, $http, $compile, NetworkService, AtlasDialog, AtlasNotification, $timeout) {

    $scope.gui = {}
    $scope.gui.profileOverlay = {visible: false};
    
    $scope.openPage = function(url){
        window.location = url;
    }
    
    $scope.setLanguage = function(language){
        var data = {};
        NetworkService.callOperation("lang/"+language, data, function(response){
            location.reload();
        })
    }
    
    $("body").on("click", function(e){
        if (e.target.id == "profile-overlay-open-button" ||e.target.id == "ac-profile-overlay" || $(e.target).parents("#ac-profile-overlay").length || $(e.target).parents("#profile-overlay-open-button").length) {

        } else {
            $timeout(function(){
                if($scope.gui != undefined && $scope.gui.profileOverlay != undefined){
                    $scope.gui.profileOverlay.visible = false;
                }
                
            },1)
        }
        
        if (e.target.id == "language-overlay-open-button" ||e.target.id == "ac-language-overlay" || $(e.target).parents("#ac-language-overlay").length || $(e.target).parents("#profile-language-open-button").length) {

        } else {
            $timeout(function(){
                if($scope.gui != undefined && $scope.gui.languageOverlay != undefined){
                    $scope.gui.languageOverlay.visible = false;
                }
                
            },1)
        }
    })
 
}])
